var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ibox row"},[(_vm.hasSlot('title'))?_c('div',{staticClass:"ibox-title"},[_vm._t("title")],2):_vm._e(),_vm._v(" "),(_vm.hasSlot('content'))?_c('div',{staticClass:"ibox-content"},[_vm._t("content")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22257f7c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Helpers/Inspinia/Ibox.vue
// module id = null
// module chunks = 